import React from "react";
import { useTranslation } from "react-i18next";

import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";

export default function ResumeUploadModal(props) {
  const { t } = useTranslation();
  const { visible, onContinue, onCancel, onIgnore, batchStatus } = props;

  const completedFiles = batchStatus?.completedFiles || 0;
  const totalFiles = batchStatus?.totalFiles || 0;
  const progress = batchStatus?.progress || 0;
  const basePath = batchStatus?.basePath || "/";

  return (
    <MDBModal staticBackdrop tabIndex="-1" closeOnEsc={false} show={visible} className="resume-upload-modal">
      <MDBModalDialog scrollable centered size="md">
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>
              <span className="title-text">{t("modals.resumeUpload.title", "Resume Upload")}</span>
            </MDBModalTitle>
          </MDBModalHeader>
          <MDBModalBody>
            <div className="resume-upload-content">
              <p className="text-value-2">
                {t("modals.resumeUpload.description", "You have an incomplete upload from a previous session.")}
              </p>
              <div className="resume-upload-info" style={{ marginTop: "16px" }}>
                <div className="info-row" style={{ marginBottom: "8px" }}>
                  <span className="label">{t("modals.resumeUpload.targetFolder", "Target folder")}:</span>
                  <span className="value" style={{ marginLeft: "8px", fontWeight: "500" }}>{basePath}</span>
                </div>
                <div className="info-row" style={{ marginBottom: "8px" }}>
                  <span className="label">{t("modals.resumeUpload.progress", "Progress")}:</span>
                  <span className="value" style={{ marginLeft: "8px", fontWeight: "500" }}>
                    {completedFiles} / {totalFiles} {t("modals.resumeUpload.files", "files")} ({progress}%)
                  </span>
                </div>
                <div className="progress-bar-container" style={{ marginTop: "16px" }}>
                  <progress value={progress} max={100} style={{ width: "100%", height: "8px" }} />
                </div>
              </div>
              <p style={{ marginTop: "16px", color: "var(--text-secondary)" }}>
                {t("modals.resumeUpload.question", "Would you like to continue uploading the remaining files?")}
              </p>
            </div>
          </MDBModalBody>
          <MDBModalFooter>
            <div className="modal-button" style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
              <button type="button" className="button neutral medium" onClick={onIgnore}>
                <span className="text p15">{t("modals.resumeUpload.ignoreButton", "Ignore for now")}</span>
              </button>
              <button type="button" className="button outline medium" onClick={onCancel}>
                <span className="text p15">{t("modals.resumeUpload.cancelButton", "Cancel upload")}</span>
              </button>
              <button type="button" className="button brand medium" onClick={() => onContinue(batchStatus)}>
                <span className="text p15">{t("modals.resumeUpload.continueButton", "Continue")}</span>
              </button>
            </div>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
}
